import { Checkbox } from '@mui/material'
import { useMemo } from 'react'
import { useTableApiContext } from '../../utils/table-context'
import { GridRenderCellParams } from '../../utils/types'

export function CheckboxSelectionCell({ row }: GridRenderCellParams) {
    const id = row.id
    const { setSelectionModel, selectionModel } = useTableApiContext()
    const checked = selectionModel.includes(id)

    return (
        <Checkbox
            checked={checked}
            onChange={e => {
                setSelectionModel(prev => {
                    if (!e.target.checked)
                        return prev.filter(selectionId => selectionId !== id)
                    return prev.concat(id)
                })
            }}
            className="size-full p-0"
            onClick={e => e.stopPropagation()}
        />
    )
}

export function CheckboxSelectionHeaderCell() {
    const { setSelectionModel, selectionModel, table } = useTableApiContext()
    const rowsLength = table?.getCoreRowModel().flatRows.length ?? 0
    const checked =
        !!selectionModel.length && selectionModel.length === rowsLength
    const indeterminate =
        selectionModel.length > 0 && selectionModel.length < rowsLength

    return useMemo(
        () => (
            <Checkbox
                checked={checked}
                indeterminate={indeterminate}
                onChange={e => {
                    setSelectionModel(
                        e.target.checked
                            ? (table
                                  ?.getCoreRowModel()
                                  .flatRows.map(row => row.original.id) ?? [])
                            : [],
                    )
                }}
            />
        ),
        [checked, indeterminate, rowsLength],
    )
}

export const SELECTION_FIELD = '__selected__'
